import { render } from "./action-table.vue?vue&type=template&id=91186ad4&scoped=true"
import script from "./action-table.vue?vue&type=script&lang=js"
export * from "./action-table.vue?vue&type=script&lang=js"

import "./action-table.vue?vue&type=style&index=0&id=91186ad4&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91186ad4"]])

export default __exports__